import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const EvaluacionPsicologica1CrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "EVALUACIÓN PSICOLÓGICA 1";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
    };
    setImages([""]);
    localStorage.removeItem("images");
  };

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result as string;
        setImages(newImages);

        localStorage.setItem("images", JSON.stringify(newImages));
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageBox = () => {
    setImages([...images, ""]);
    setNotes([...notes, ""]);
  };

  const removeImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedNotes = notes.filter((_, i) => i !== index);
    setImages(updatedImages);
    setNotes(updatedNotes);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFechaPS = useMutationData({
    url: `/fecha_psico/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_psico"],
  });

  const mutateConclusionPS = useMutationData({
    url: `/conclusionllenada_ps/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_ps"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        lugar_nacimiento: queryEvaluado.data.lugar_nacimiento || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-gray-200" : "bg-white text-gray-900"}`}>
      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_evaluacionps" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>
            FECHA:
          </Label>
          <Controller
            name="fecha_evaluacionps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_evaluacionps"
                type="date"
                placeholder="Seleccionar fecha"
                {...field}
                className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            value={generoTexto}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={`${queryEvaluado.data?.estado_civil || ""}`}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={`${queryEvaluado.data?.escolaridad || ""}`}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
            disabled={true}
            type="date"
            onChange={handleInputChange}
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-300" : "text-gray-900"}`}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">
          EVALUACIÓN PSICOLÓGICA 1
        </h2>
      </div>

      {/* Tabla */}
      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-gray-200 border-gray-700" : "bg-white text-gray-900 border-gray-500"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-gray-200" : "bg-blue-500 text-black"}`}>
              <th className="py-3 px-4 border border-gray-300 text-center">
                ÁMBITO FAMILIAR
              </th>
              <th className="py-3 px-4 border border-gray-300 text-center">
                PERSONALIDAD
              </th>
              <th className="py-3 px-4 border border-gray-300 text-center">
                HÁBITOS
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border border-gray-300 text-center">
                Estado Civil
              </th>
              <th className="py-2 px-4 border border-gray-300 text-center">
                Describa como es su carácter
              </th>
              <th className="py-2 px-4 border border-gray-300 text-center">
                ¿Qué tipo de drogas conoce?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border border-gray-300">
                <textarea
                  className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                  value={
                    queryEvaluado.data?.estado_civil
                      ? queryEvaluado.data.estado_civil
                          .charAt(0)
                          .toUpperCase() +
                        queryEvaluado.data.estado_civil.slice(1)
                      : ""
                  }
                  placeholder="Estado Civil"
                  disabled={true}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="personalidad_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="personalidad_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Personalidad"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="tipodrogas_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="tipodrogas_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Ejemplo: Alcohol, tabaco, etc"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-3 px-4 border border-gray-300 text-center">
                Integrantes de su Familia
              </th>
              <th className="py-3 px-4 border border-gray-300 text-center">
                AUTODESCRIPCIÓN
              </th>
              <th className="py-2 px-4 border border-gray-300 text-center">
                Describa las situaciones en que consume alcohol
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="integrantes_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="integrantes_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Integrantes"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="describe_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="describe_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Descripción"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="cuandoconsume_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="cuandoconsume_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Cuando..."
                    />
                  )}
                />
              </td>

            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border border-gray-300 text-center">
                ¿Con quién se identifica de su familia y por qué?
              </th>
              <th className="py-2 px-4 border border-gray-300 text-center">
                ¿Qué es lo que más le han criticado de su forma de ser?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="identifica_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="identifica_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Razón de identificación"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="formaser_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="formaser_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Críticas recibidas"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className="text-black">
              <th className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
                Describa como es la relación con su familia
              </th>
              <th className={`${isDarkMode ? "bg-blue-800 text-gray-200" : "bg-blue-500 text-black"}`}>
                RELACIONES INTERPERSONALES
              </th>
            </tr>
          </thead>
          <thead>
            <tr className="text-black">
              <td className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
                <Controller
                  name="relacionfam_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="relacionfam_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Relación con la familia"
                    />
                  )}
                />
              </td>
              <th className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
                Describe como son las personas con las que se identifica
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border border-gray-300"></td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="personas_identificaps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="personas_identificaps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Se identifica"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300"></td>
            </tr>
          </thead>
          <thead>
            <tr className="text-black">
              <td className="py-2 px-4 border border-gray-300"></td>
              <th className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
                Describa como son las personas con las que no se lleva bien
              </th>
              <td className="py-2 px-4 border border-gray-300"></td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border border-gray-300"></td>
              <td className="py-2 px-4 border border-gray-300">
                <Controller
                  name="noidentifica_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="noidentifica_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="¿Como son?"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border border-gray-300"></td>
            </tr>
          </thead>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table className={`min-w-full rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-gray-200 border-gray-700" : "bg-white text-gray-900 border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-800 text-gray-200" : "bg-blue-500 text-black"}`}>
              <th className="py-3 px-4 border-b text-center">
                APEGO A NORMAS Y VALORES
              </th>
              <th className="py-3 px-4 border-b text-center">
                CONTROL DE IMPULSOS
              </th>
              <th className="py-3 px-4 border-b text-center">SALUD</th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Procedimientos administrativos o jurídicos
              </th>
              <th className="py-2 px-4 border-b text-center">
                Explique cuales son los motivos por lo que se enoja
              </th>
              <th className="py-2 px-4 border-b text-center">
                ¿Cómo considera su estado de salud?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="procedimientosadm_ps"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <select
                      {...field}
                      id="procedimientosadm_ps"
                      className={`border rounded-md p-2 w-20 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                      onChange={(e) => {
                        const value =
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : null;
                        field.onChange(value);
                      }}
                    >
                      <option value="">Elige</option>
                      <option value="true">Sí</option>
                      <option value="false">No</option>
                    </select>
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="motivoenojo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="motivoenojo_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      aria-label="motivoenojo_ps"
                      placeholder="Describe los motivos de enojo aquí..."
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="estadosalud_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="estadosalud_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Estado de salud"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Qué me dirían sus jefes y maestros de usted?
              </th>
              <th className="py-2 px-4 border-b text-center">
                Describa cómo reacciona cuando es agredido
              </th>
              <th className="py-2 px-4 border-b text-center">Enfermedades</th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="opinionpersona_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="opinionpersona_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Opinión..."
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="agredido_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="agredido_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Reacción al ser agredido"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="tratamientomedico_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="tratamientomedico_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Tratamiento Médico"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa que es lo mejor que ha hecho hasta hoy
              </th>
              <th className="py-2 px-4 border-b text-center">
                Cuénteme como fue la última riña en la que participó
              </th>
              <th className="py-2 px-4 border-b text-center">
                Tratamientos médicos prolongados
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="mejor_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="mejor_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Lo mejor que ha hecho"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="cualriña_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="cualriña_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Riñas..."
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="derivado1_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="derivado1_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Enfermedades"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-700 text-gray-200" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa que es lo peor que ha hecho hasta hoy
              </th>
              <th className="py-2 px-4 border-b text-center">
                Describa como es su estado de ánimo actual
              </th>
              <th className="py-2 px-4 border-b text-center">
                Tratamientos psicológicos o psiquiátricos
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="peor_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="peor_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Lo peor que ha hecho"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="estadoanimo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="estadoanimo_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Animo..."
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="tratamientops_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="tratamientops_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Psicológico/psiquiátrico"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b"></td>
              <th className="py-2 px-4 border-b text-center">
                Describa el acontecimiento más triste que ha vivido
              </th>
              <td className="py-2 px-4 border-b"></td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b"></td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="acontecimientotriste_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="acontecimientotriste_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Acontecimiento mas triste"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b"></td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b"></td>
              <th className="py-2 px-4 border-b text-center">
                ¿Cómo se refleja la tristeza en su vida cotidiana?
              </th>
              <td className="py-2 px-4 border-b"></td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <td className="py-2 px-4 border-b"></td>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="tristezavida_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="tristezavida_ps"
                      className={`w-full p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                      placeholder="Como se refleja la tristeza"
                    />
                  )}
                />
              </td>
              <td className="py-2 px-4 border-b"></td>
            </tr>
          </thead>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table className={`min-w-full border rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
              <th className="py-3 px-4 border-b text-center">ÁMBITO LABORAL</th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Cuál es el motivo por el que entró a trabajar a la empresa?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="motivo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="motivo_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Motivo de entrar a la empresa"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Cómo se enteró de la vacante?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="enterovacante_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="enterovacante_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Cómo se enteró de la vacante"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Qué actividades realiza en la empresa?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="actividadesempresa_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="actividadesempresa_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Actividades..."
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Qué opina de los problemas que se pueden presentar en la
                empresa?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="problemasempresa_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="problemasempresa_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Problemas en la empresa"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Cómo puede contribuir a resolverlos?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="resolverproblemas_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="resolverproblemas_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Cómo contribuiría a resolverlos"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Cuáles fueron sus empleos anteriores?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="reseñaempleos_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="reseñaempleos_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Empleos anteriores"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa lo que más le gustaba de su último trabajo
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="descripciongustatrabajo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="descripciongustatrabajo_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      aria-label="descripciongustatrabajo_ps"
                      placeholder="Descripción de su último trabajo..."
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa lo que menos le gustaba de su último trabajo
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="descripciondisgustatrabajo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="descripciondisgustatrabajo_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      aria-label="descripciondisgustatrabajo_ps"
                      placeholder="Descripción de su último trabajo..."
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa como ha sido su relación con jefes y compañeros
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="relacionjefecomp_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="relacionjefecomp_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Relación con jefes y compañeros"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Cuál es la situación más difícil que ha enfrentado en el
                trabajo?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="situaciontrabajo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="situaciontrabajo_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Situación difícil en el trabajo"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa su mayor logro personal y laboralmente
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="logropersonal_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="logropersonal_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      aria-label="descripciondisgustatrabajo_ps"
                      placeholder="Mayor logro personal y laboral"
                    />
                  )}
                />
                <Controller
                  name="logrolaboral_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="logrolaboral_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      aria-label="descripciondisgustatrabajo_ps"
                      placeholder="Mayor logro personal y laboral"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Describa una situación imprevista o bajo presión en la que tuvo
                que tomar decisiones, como actuó y qué resultados obtuvo
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="situacionimprevista_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="situacionimprevista_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Situación difícil en el trabajo"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Qué actividades realiza en su tiempo libre?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="tiempolibre_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="tiempolibre_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Actividades en tiempos libres"
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                Información adicional y/o comentarios
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="infoadicional_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="infoadicional_ps"
                      className={`w-full p-2 border rounded text-justify ${
                        isDarkMode 
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400" 
                          : "bg-white border-gray-300 text-black focus:ring-blue-500 focus:border-blue-500"
                      } focus:outline-none focus:ring-2`}
                      placeholder="Información..."
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table className={`min-w-full border rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
              <th className="py-3 px-4 border-b text-center">
                COMPETENCIAS LABORALES
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-400 text-black"}`}>
              <th className="py-3 px-4 border-b text-center">ADAPTABILIDAD</th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Qué tan rápido o lento es que usted se adapte a nuevas
                actividades y a los cambios tanto laborales como sociales?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="adaptacion_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select
                      {...field}
                      id="adaptacion_ps"
                      className={`border rounded-md p-2 w-40 inline-block mt-2 mb-2 focus:ring-2 ${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                          : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                      } placeholder-gray-500`}
                    >
                      <option value="">Elige</option>
                      <option value="Rápidamente">Rápidamente</option>
                      <option value="Lentamente">Lentamente</option>
                    </select>
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-400 text-black"}`}>
              <th className="py-3 px-4 border-b text-center">
                RESPONSABILIDAD
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Cumple con la entrega de los trabajos encomendados el día y
                hora que se requiere?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="manifiesta_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select
                      {...field}
                      id="manifiesta_ps"
                      className={`border rounded-md p-2 w-40 inline-block mt-2 mb-2 focus:ring-2 ${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                          : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                      } placeholder-gray-500`}
                    >
                      <option value="">Elige</option>
                      <option value="Sí cumple">Sí cumple</option>
                      <option value="No cumple">No cumple</option>
                    </select>
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Acude a su trabajo en los horarios establecidos de manera
                puntual?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="indicaacude_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select
                      {...field}
                      id="indicaacude_ps"
                      className={`border rounded-md p-2 w-40 inline-block mt-2 mb-2 focus:ring-2 ${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                          : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                      } placeholder-gray-500`}
                    >
                      <option value="">Elige</option>
                      <option value="Acude">Acude</option>
                      <option value="No Acude">No Acude</option>
                    </select>
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-500 text-white" : "bg-blue-400 text-black"}`}>
              <th className="py-3 px-4 border-b text-center">
                TRABAJO EN EQUIPO
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b text-center">
                ¿Con qué facilidad se adapta usted a trabajar en equipo?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b text-center">
                <Controller
                  name="adaptaequipo_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select
                      {...field}
                      id="adaptaequipo_ps"
                      className={`border rounded-md p-2 w-60 inline-block mt-2 mb-2 focus:ring-2 ${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                          : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                      } placeholder-gray-500`}
                    >
                      <option value="">Elige</option>
                      <option value="Se integra rápido">
                        Se integra rápido
                      </option>
                      <option value="No le agrada pero lo hace">
                        No le agrada, pero lo hace
                      </option>
                      <option value="No le gusta">No le gusta</option>
                    </select>
                  )}
                />
              </td>
            </tr>
          </thead>
        </table>
      </div>

      <div className="w-full overflow-x-auto">
        <table className={`min-w-full border rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
              <th className="py-3 px-4 border-b text-left">
                TOMA DE DECISIONES
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b">
                ¿En situaciones de emergencia en sus actividades laborales, toma
                usted decisiones asertivas y rápidas para la solución de
                conflictos?
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="tomadecision_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select
                      {...field}
                      id="tomadecision_ps"
                      className={`border rounded-md p-2 w-60 inline-block mt-2 mb-2 focus:ring-2 ${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                          : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                      } placeholder-gray-500`}
                    >
                      <option value="">Elige</option>
                      <option value="Rápidas y Asertivas">
                        Rápidas y Asertivas
                      </option>
                      <option value="No">No</option>
                    </select>
                  )}
                />
              </td>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
              <th className="py-3 px-4 border-b text-left">
                TOLERANCIA A LA PRESIÓN
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
              <th className="py-2 px-4 border-b">
                Mencione un proyecto desafiante, con una fecha límite ajustada,
                explique los métodos que se tomaron y realce los resultados
              </th>
            </tr>
          </thead>
          <thead>
            <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
              <td className="py-2 px-4 border-b">
                <Controller
                  name="tolerancia_ps"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <textarea
                      {...field}
                      id="tolerancia_ps"
                      className={`w-full p-2 border rounded focus:outline-none focus:ring-2 ${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                          : "bg-white border-gray-300 text-black focus:ring-blue-500"
                      }`}
                      aria-label="tolerancia_ps"
                      placeholder="Descripción..."
                    />
                  )}
                />
              </td>
            </tr>
          </thead>
        </table>

        <div className="w-full overflow-x-auto">
          <table className={`min-w-full border rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-300"}`}>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
                <th className="py-3 px-4 border-b text-left">
                  COMPROMISO LABORAL
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
                <th className="py-2 px-4 border-b">
                  ¿Sientes que tu trabajo tiene un propósito y contribuye al
                  éxito de la empresa?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="compromiso_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="compromiso_ps"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                            : "bg-white border-gray-300 text-black focus:ring-blue-500"
                        }`}
                        aria-label="tolerancia_ps"
                        placeholder="Descripción..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
                <th className="py-3 px-4 border-b text-left">LIDERAZGO</th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
                <th className="py-2 px-4 border-b">
                  Mencione brevemente un momento en el que demostró sus
                  habilidades de liderazgo
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="lider_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="lider_ps"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                            : "bg-white border-gray-300 text-black focus:ring-blue-500"
                        }`}
                        aria-label="lider_ps"
                        placeholder="Descripción..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
                <th className="py-2 px-4 border-b">
                  ¿Qué valores son los más importantes para usted como líder?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="valoresusted_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="valoresusted_ps"
                        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                            : "bg-white border-gray-300 text-black focus:ring-blue-500"
                        }`}
                        aria-label="valoresusted_ps"
                        placeholder="¿Cuáles?"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-600 text-white" : "bg-blue-500 text-black"}`}>
                <th className="py-3 px-4 border-b text-left">INICIATIVA</th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
                <th className="py-2 px-4 border-b">
                  En alguna ocasión, ha tenido que asumir mayor responsabilidad
                  en tu trabajo, ¿de lo que te correspondía?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="ocasion_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="ocasion_ps"
                        type="text"
                        className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                            : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                        } placeholder-gray-500`}
                        placeholder="Ocasión responsabilidad"
                      />
                    )}
                  />{" "}
                  ¿Porque?{" "}
                  <Controller
                    name="derivado2_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <input
                        {...field}
                        id="derivado2_ps"
                        type="text"
                        className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400"
                            : "bg-white border-gray-300 text-gray-700 focus:ring-indigo-400"
                        } placeholder-gray-500`}
                        placeholder="Razón responsabilidad"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "bg-blue-400 text-white" : "bg-blue-200 text-black"}`}>
                <th className="py-2 px-4 border-b">
                  ¿Cuáles son tus objetivos inmediatos y que haces para
                  conseguirlos?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className={`${isDarkMode ? "text-gray-300" : "text-black"}`}>
                <td className="py-2 px-4 border-b">
                  <Controller
                    name="objetivos_ps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="objetivos_ps"
                        className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 resize-none ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600 text-gray-300 focus:ring-blue-400 focus:border-blue-400"
                            : "bg-white border-gray-300 text-gray-900 focus:ring-indigo-500 focus:border-indigo-500"
                        } placeholder-gray-400`}
                        aria-label="objetivos_ps"
                        placeholder="Objetivos inmediatos"
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`container mx-auto p-4`}>
        <form
          onSubmit={handleSubmit((data) => {
            const formData = {
              ...data,
            };

            // Primero, enviamos la fecha (como ya lo hacías)
            mutateFechaPS.mutate(
              {
                data: { fecha_evaluacionps: data.fecha_evaluacionps },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  mutateConclusionPS.mutate(
                    {
                      data: formData,
                      tipo: "post",
                    },
                    {
                      onSuccess: () => {
                        navigate(`/psicologica/${evaluadosList_id}`);
                      },
                      onError: (error) => {
                        console.error("Detalles del error:", error.response.data);
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error("Error al guardar Fecha Psicologica:", error);
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className={`mt-6 p-4 flex justify-between ${isDarkMode ? "bg-gray-800 border-t border-gray-700" : "bg-white border-t border-gray-200"}`}>
            {/* Botón Cancelar */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/psicologica/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800 text-white" : "bg-red-400 text-white"}`}
              >
                Cancelar
              </Button>
            )}

            {/* Botón Siguiente */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-800 text-white" : "bg-blue-400 text-white"}`}
              >
                Siguiente
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-violet-600 hover:bg-violet-800 text-white" : "bg-violet-400 text-white"}`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button
                  type="submit"
                  className={`ml-2 ${isDarkMode ? "bg-green-600 hover:bg-green-800 text-white" : "bg-green-400 text-white"}`}
                >
                  Guardar
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
